import React, { useState } from 'react'
import { Button, Form, FormGroup, Input, Label } from 'reactstrap'
import EmailEditor from '../../components/Email/EmailEditor'
import EmailLayout from '../../components/Email/EmailLayout'
import CAlert from '../../components/sharedComponents/CAlert'
import { createEmailTemplates } from '../../actions/emailTemplateAction'

const CreateEmailTemplate = props => {

    const { authenticated, userDetails } = props

    const [name, setName] = useState('')
    const [subject, setSubject] = useState('')
    const [editorValue, setEditorValue] = useState('')
    const [isCreated, setIsCreated] = useState(false)
    const [errorText, setErrorText] = useState(null)
    const [isLoading, setIsloading] = useState(false)

    function templateCreated() {
        setIsCreated(true)
        setName('')
        setSubject('')
        setEditorValue('')
    }

    function renderError(err) {
        setErrorText(err)
        isLoading && setIsloading(false)
        return
    }

    const handleOnCreate = async e => {
        e.preventDefault()

        if (!authenticated || name === '') return

        const user_id = userDetails.user._id

        const reqBody = {
            user_id,
            name,
            subject,
            content: editorValue
        }
        setIsloading(true)
        await createEmailTemplates(reqBody, () => {
            setIsCreated(true)
            templateCreated()
            setIsloading(false)

        }, renderError)
    }

    return <EmailLayout title='Create Email Template'>
        <CAlert show={errorText !== null} text={errorText} color='danger' />
        <CAlert onClick={() => setIsCreated(false)} show={isCreated} text='Successfully Created!' color='success' timeout />

        <Form onSubmit={e => handleOnCreate(e)}>
            <FormGroup>
                <Label>Template Name</Label>
                <Input
                    type="text"
                    value={name || ''}
                    placeholder="name"
                    onChange={e => setName(e.target.value)}
                    required
                />
            </FormGroup>
            <FormGroup>
                <Label>Subject</Label>
                <Input
                    type="text"
                    value={subject || ''}
                    placeholder="subject"
                    onChange={e => setSubject(e.target.value)}
                    required
                />
            </FormGroup>

            <Label for="exampleSelect">Content</Label>
            <EmailEditor reset={isCreated}
                editorChange={(value) => setEditorValue(value)} />
            <br />
            <center>
                <Button color='info'>Create Template</Button>
            </center>
        </Form>

    </EmailLayout>
}

export default CreateEmailTemplate;